import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "modal modal--user",
  id: "modal-broker-add"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_10 = {
  key: 0,
  class: "flashmessage flash-danger"
}
const _hoisted_11 = { class: "form-section has-aside" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { for: "frm-estateAgentForm_firstName" }
const _hoisted_14 = {
  key: 0,
  class: "form-error"
}
const _hoisted_15 = { for: "frm-estateAgentForm_lastName" }
const _hoisted_16 = {
  key: 0,
  class: "form-error"
}
const _hoisted_17 = { for: "frm-estateAgentForm_email" }
const _hoisted_18 = {
  key: 0,
  class: "form-error"
}
const _hoisted_19 = {
  key: 1,
  class: "form-error"
}
const _hoisted_20 = { for: "frm-estateAgentForm_confirmEmail" }
const _hoisted_21 = { class: "help" }
const _hoisted_22 = {
  key: 0,
  class: "form-error"
}
const _hoisted_23 = {
  key: 1,
  class: "form-error"
}
const _hoisted_24 = { for: "frm-estateAgentForm_phoneNumber" }
const _hoisted_25 = { class: "multiple-inputs" }
const _hoisted_26 = { class: "selectbox selectbox--phone-prefix" }
const _hoisted_27 = {
  key: 0,
  class: "form-error"
}
const _hoisted_28 = {
  key: 0,
  class: "form-error"
}
const _hoisted_29 = {
  key: 1,
  class: "form-error"
}
const _hoisted_30 = { class: "form-field" }
const _hoisted_31 = { for: "frm-estateAgentForm_role" }
const _hoisted_32 = { class: "selectbox" }
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "form-section-aside"
}
const _hoisted_35 = { class: "form-upload-photo aspect-ratio aspect-ratio-1-1" }
const _hoisted_36 = { class: "aspect-ratio-body" }
const _hoisted_37 = {
  key: 0,
  class: "photo is-uploaded"
}
const _hoisted_38 = {
  key: 1,
  class: "upload-placeholder placeholder-user"
}
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = {
  key: 0,
  class: "form-error"
}
const _hoisted_41 = { class: "form-footer" }
const _hoisted_42 = { class: "buttons-inline" }
const _hoisted_43 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhonePrefix = _resolveComponent("PhonePrefix")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "modal-close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('EstateAgentInsert.title')), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('EstateAgentInsert.subtitle')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", {
                id: "estateAgent-form",
                class: "form",
                onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                (_ctx.isError || _ctx.errors.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_ctx.isError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "flashmessage flash-danger"
                        }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.firstName.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('EstateAgentInsert.firstName')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.firstName.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentForm_firstName",
                        name: "firstName",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.firstName.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.firstName.$dirty && _ctx.v$.form.firstName.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.firstName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.lastName.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('EstateAgentInsert.lastName')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.form.lastName.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentForm_lastName",
                        name: "lastName",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.lastName.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.lastName.$dirty && _ctx.v$.form.lastName.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.lastName.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.email.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('EstateAgentInsert.email')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.form.email.$model) = $event)),
                        type: "text",
                        id: "frm-estateAgentForm_email",
                        name: "email",
                        class: "form-control is-required"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.v$.form.email.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.form.email.$dirty && _ctx.v$.form.email.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.email.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.email.email.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('forms.email')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmEmail.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('EstateAgentInsert.email')) + ":", 1),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.form.confirmEmail.$model) = $event)),
                        onPaste: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                        type: "text",
                        id: "frm-estateAgentForm_confirmEmail",
                        name: "confirmEmail",
                        class: "form-control is-required"
                      }, null, 544), [
                        [
                          _vModelText,
                          _ctx.v$.form.confirmEmail.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('EstateAgentInsert.email-help-confirm')), 1),
                      (_ctx.v$.form.confirmEmail.$dirty && _ctx.v$.form.confirmEmail.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.confirmEmail.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.confirmEmail.sameAsEmail.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.$t('EstateAgentInsert.email-mismatch')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.phoneNumber.$error }])
                    }, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('EstateAgentInsert.phoneNumber')) + ":", 1),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_PhonePrefix, {
                            id: "frm-estateAgentForm_phoneNumberPrefix",
                            modelValue: _ctx.v$.form.phoneNumberPrefix.$model,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.form.phoneNumberPrefix.$model) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.form.phoneNumber.$model) = $event)),
                          type: "text",
                          id: "frm-estateAgentForm_phoneNumber",
                          placeholder: "900 000 000",
                          name: "phoneNumber",
                          class: "form-control is-required"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.v$.form.phoneNumber.$model,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      (_ctx.v$.form.phoneNumberPrefix.$dirty && _ctx.v$.form.phoneNumberPrefix.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.v$.form.phoneNumberPrefix.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      ((_ctx.v$.form.phoneNumberPrefix.$dirty || _ctx.v$.form.phoneNumber.$dirty) && _ctx.v$.form.phoneNumber.$invalid)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.v$.form.phoneNumber.required.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('forms.required')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.v$.form.phoneNumber.phoneNumber.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('forms.phone-number')), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('EstateAgentInsert.role')) + ":", 1),
                      _createElementVNode("div", _hoisted_32, [
                        _withDirectives(_createElementVNode("select", {
                          id: "frm-estateAgentForm_role",
                          name: "role",
                          class: "form-control is-required",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedRole) = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: role.key,
                              key: role.key
                            }, _toDisplayString(role.value), 9, _hoisted_33))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.selectedRole]
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.estateAgentImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["form-field", { 'is-danger': _ctx.estateAgentImage.isError }])
                        }, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              (_ctx.estateAgentImage.isSuccess)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    (_ctx.estateAgentImage.isSuccess)
                                      ? (_openBlock(), _createBlock(_component_ResizableImage, {
                                          key: 0,
                                          url: _ctx.estateAgentImage.url,
                                          width: 260,
                                          height: 195,
                                          hrmode: "max",
                                          alt: _ctx.estateAgentImage.file,
                                          draggable: false
                                        }, null, 8, ["url", "alt"]))
                                      : _createCommentVNode("", true),
                                    (_ctx.estateAgentImage.isSuccess)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteEstateAgentFile())),
                                          class: "delete-photo"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("label", _hoisted_38, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/jpeg",
                                      ref: "estateAgentImage",
                                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleEstateAgentImageUpload()))
                                    }, null, 544),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('EstateAgentInsert.photo-button')), 1),
                                    _createElementVNode("i", {
                                      innerHTML: _ctx.$t('EstateAgentInsert.photo-button-info')
                                    }, null, 8, _hoisted_39)
                                  ])),
                              (_ctx.estateAgentImage.isUploading)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "progress-bar",
                                    style: _normalizeStyle({ width: _ctx.estateAgentImage.uploadPercentage + '%' })
                                  }, null, 4))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_ctx.estateAgentImage.isError)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.estateAgentImage.text), 1))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("button", _hoisted_43, _toDisplayString(_ctx.$t('EstateAgentInsert.button-save')), 1),
                    _createElementVNode("button", {
                      class: "button button--danger",
                      type: "button",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, _toDisplayString(_ctx.$t('EstateAgentInsert.button-cancel')), 1)
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}